import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import format from 'date-fns/format'

type Props = {
  currentMonth: Date
}

const CloseStoreCalendarLabel: FC<Props> = (props) => {
  const { currentMonth } = props

  return <p className={styles.label__monthly}>{format(currentMonth, 'yyyy年M月')}</p>
}

export default CloseStoreCalendarLabel
